export default __webpack_public_path__ + "static/media/m-slide-2.8a878a34.png";